<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col cols="5">
          <v-card style="min-height: 88vh">
            <v-card-title>
              Value
              <v-spacer></v-spacer>
              <v-btn
                fab
                x-small
                color="primary"
                @click="isCreateDialogOpen = true"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="scroll-container">
              <v-progress-linear
                v-if="isLoading"
                indeterminate
                color="primary"
              ></v-progress-linear>
              <v-list v-else>
                <template v-for="(value, index) in values">
                  <v-list-item :key="`value_${index}`">
                    <v-list-item-content>
                      <v-list-item-title>{{ value.name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-row>
                        <v-col>
                          <v-btn
                            color="primary"
                            @click="getValueList(value)"
                            small
                          >
                            List
                          </v-btn>
                        </v-col>
                        <v-col class="py-1 px-0">
                          <v-btn
                            icon
                            color="indigo"
                            large
                            @click="editDialogOpen(value)"
                          >
                            <v-icon dark> mdi-pencil-circle-outline </v-icon>
                          </v-btn>
                        </v-col>
                        <v-col class="py-1 px-0">
                          <v-btn
                            icon
                            color="red"
                            large
                            @click="openDeleteDialog(value.id)"
                          >
                            <v-icon dark> mdi-delete-circle-outline </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index !== values.length - 1"
                    :key="index"
                    class="my-1"
                  ></v-divider>
                </template>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="7">
          <v-card
            style="min-height: 88vh; display: flex; flex-direction: column"
          >
            <v-card-title>
              <span v-if="!selectedValue || !selectedValue.name"
                >Value List</span
              >
              <span v-else>Value List [ {{ selectedValue.name }} ]</span>

              <v-spacer></v-spacer>
              <v-btn
                v-if="selectedValue"
                fab
                x-small
                color="primary"
                @click="addEmptyValueList"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="scroll-container">
              <v-list v-if="!isLoadingList">
                <h2
                  v-if="valueLists.length === 0"
                  class="text-center font-weight-bold"
                  style="color: gray"
                >
                  No Data
                </h2>
                <template
                  v-else
                  v-for="(valueList, valueListIndex) in valueLists"
                >
                  <v-list-item :key="`value_list_${valueListIndex}`">
                    <v-list-item-content>
                      <v-row>
                        <v-col>
                          <v-text-field
                            v-model="valueList.description"
                            outlined
                            dense
                            label="Description"
                            @input="
                              valueList.description =
                                valueList.description.toUpperCase()
                            "
                            hide-details="auto"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="valueList.code"
                            :input="
                              (valueList.code = valueList.code.toUpperCase())
                            "
                            outlined
                            dense
                            label="Code"
                            hide-details="auto"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-row>
                        <v-col class="py-0 pr-0">
                          <v-btn
                            icon
                            color="error"
                            @click="deleteValueList(valueListIndex)"
                            x-large
                          >
                            <v-icon dark> mdi-delete-circle-outline </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="valueListIndex !== valueLists.length - 1"
                    :key="valueListIndex"
                    class="my-2"
                  ></v-divider>
                </template>
              </v-list>
              <v-progress-linear
                v-else
                indeterminate
                color="primary"
              ></v-progress-linear>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="saveValueList"> Save List </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Create Value Dialog -->
      <v-dialog v-model="isCreateDialogOpen" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Create New Value</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              @input="form.name = form.name.toUpperCase()"
              v-model="form.name"
              label="Value Name"
              outlined
              hide-details="auto"
              dense
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" @click="isCreateDialogOpen = false">
              Cancel
            </v-btn>
            <v-btn color="primary" @click="save" :loading="isLoadingSave">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Edit Value Dialog -->
      <v-dialog v-model="isEditDialogOpen" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Edit New Value</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              @input="form.name = form.name.toUpperCase()"
              v-model="form.name"
              label="Value Name"
              outlined
              hide-details="auto"
              dense
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" @click="isEditDialogOpen = false">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="updateValue"
              :loading="isLoadingSave"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Confirmation Value Dialog -->
      <DeleteConfirmationDialog
        v-if="selectedId !== null"
        :itemId="selectedId"
        @delete="deleteData"
        ref="deleteDialog"
      />
    </v-container>
  </v-main>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";

export default {
  components: { DeleteConfirmationDialog },
  name: "ValuesPage",
  data() {
    return {
      form: { id: "", name: "" },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      values: [],
      valueLists: [],
      selectedValue: [],
      selectedId: null,
      isLoading: false,
      isLoadingSave: false,
      isLoadingList: false,
      isCreateDialogOpen: false,
      isEditDialogOpen: false,
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let values = await axios.get(`/values`);
      this.values = values.data.data;
      this.count = values.data.count;
      this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      this.isLoading = false;
    },
    async editDialogOpen(value) {
      this.form.id = value.id;
      this.form.name = value.name;
      this.isEditDialogOpen = true;
    },
    async updateValue() {
      try {
        this.isLoadingSave = true;
        await axios.patch(`/values/${this.encryptIt(this.form.id)}`, this.form);
        this.form = {
          id: "",
          name: "",
        };
        this.getData();
        this.form = { id: "", name: "" };
        this.isLoadingSave = false;
        this.isEditDialogOpen = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async getValueList(value) {
      this.isLoadingList = true;
      this.selectedValue = value;
      let valueLists = await axios.get(`/values/${value.id}/value_lists`);
      this.valueLists = valueLists.data.data;
      this.count = valueLists.data.count;
      this.isLoadingList = false;
    },
    async save() {
      try {
        this.isLoadingSave = true;
        await axios.post("/values", this.form);
        this.getData();
        this.form = { id: "", name: "" };
        this.isCreateDialogOpen = false;
        this.isLoadingSave = false;
      } catch (e) {
        // alert("error");
        this.isLoading = false;
      }
    },
    async saveValueList() {
      if (this.valueLists.length > 0) {
        this.isLoadingList = true;
        let payload = {
          datas: this.valueLists,
        };

        let response = await axios.post(
          `/values/${this.selectedValue.id}/multiple_value_lists`,
          payload
        );
        this.valueLists = response.data.data;
        this.isLoadingList = false;
      }
    },
    addEmptyValueList() {
      this.valueLists.push({
        value_id: this.selectedValue.id,
        company_id: this.company.id,
        description: "",
        code: "",
        is_active: 1,
      });
      console.log("this.valueLists", this.valueLists);
    },
    openDeleteDialog(id) {
      this.selectedId = id;
      this.$nextTick(() => {
        this.$refs.deleteDialog.openDialog();
      });
    },
    async deleteData(id) {
      this.delete_user = true;
      await axios
        .post(`/values/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_user = false;
          this.is_deleted_user = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
    deleteValueList(index) {
      this.valueLists.splice(index, 1);
    },
  },
};
</script>

<style scoped>
/* Styling for the scroll container */
.scroll-container {
  flex: 1;
  overflow-y: auto;
  max-height: calc(85.5vh - 100px);
  border-radius: 10px; /* Rounded edges */
  padding: 8px; /* Optional padding for smooth edges */
}

/* Custom Scrollbar */
.scroll-container::-webkit-scrollbar {
  width: 8px;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scroll-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
